<template>
  <ul class="list-group">
    <li
      @click="showDetail(a)"
      class="list-group-item list-group-item-action d-flex align-items-center bd-0"
      v-for="(a, i) in attachments"
      :key="i"
      role="button"
    >
      <div class="avatar">
        <span
          :class="`avatar-initial rounded-cirlce bg-transparent`"
          v-if="getFileIcon(a.e) == 'image' || getFileIcon(a.e) == 'video'"
        >
          <img
            v-if="getFileIcon(a.e) == 'image'"
            :src="`${a.l}?w=60&h=60&mode=pad`"
            class="rounded"
          />
          <img
            v-else-if="getFileIcon(a.e) == 'video'"
            :src="`${a.c}?w=600&h=60&mode=pad`"
            class="rounded"
          />
        </span>
        <span
          :class="`avatar-initial rounded-circle bg-transparent bd bd-gray-900`"
          v-else
        >
          <i
            :class="
              `tx-18 far tx-color-03 fa-file-${getFileIcon(a.e)} ${getFileIcon(
                a.e
              )}`
            "
          ></i>
        </span>
      </div>
      <div class="pd-l-10">
        <h6 class="tx-14 tx-semibold mg-b-5">
          {{ a.t != "" ? a.t : a.n }}
        </h6>
        <span class="tx-11 text-uppercase">
          <feather
            :type="a.isCompleted ? 'check-square' : 'square'"
            stroke-width="1"
            class="mg-r-5 tx-color-01"
          ></feather>
          {{ a.e }}
        </span>
        <span
          class="tx-11 text-uppercase mg-l-10"
          v-if="a.dur != null && a.dur != ''"
          >{{ a.dur }} мин</span
        >
      </div>
      <button
        class="btn btn-xs btn-outline-light btn-uppercase d-flex mg-l-auto"
      >
        <span class="mg-r-5">үзэх</span>
        <feather type="eye"></feather>
      </button>
    </li>
  </ul>
  <!-- <div class="row row-xs">
    <div
      class="col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-2"
      v-for="(a,i) in attachments"
      :key="i"
    >
      <div @click="showDetail(a)" class="card card-file" role="button">
        <div class="card-file-thumb overflow-hidden">
          <img   
            v-if="getFileIcon(a.e)=='image'"
            :src="`${a.l}?w=280&h=120&mode=pad`"
            class="wd-100p"
          />
          <img   
            v-else-if="getFileIcon(a.e)=='video'"
            :src="`${a.c}?w=280&h=120&mode=pad`"
            class="wd-100p"
          />
          <i v-else :class="`far fa-file-${getFileIcon(a.e)}`"></i>
        </div>
        <div class="card-body">
          <div class="d-flex">

            <div class="avatar avatar-sm mg-r-10 wd-18p">
              <span
                :class="`avatar-initial rounded-circle bg-${a.isCompleted?'success-light':'gray-700'} text-white`"
              >
                <feather v-if="a.isCompleted" type="check" :size="16"></feather>
                <i v-else :class="`far fa-file-${getFileIcon(a.e)}`"></i>
              </span>
            </div>
            <div class="wd-80p">
              <h6>
                <a class="link-02">{{a.t!='' ? a.t : a.n}}</a>
              </h6>

              <div class="d-flex justify-content-between">
                <p class="tx-12 text-muted text-uppercase">{{a.e}}</p>
                <span>{{getSize(a.s)}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->
</template>

<script>
import { getSize, getFileIcon } from "@/libs/tools";

export default {
  props: {
    box: {
      type: Object,
      default: () => {}
    },
    attachments: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getSize(size) {
      return getSize(size);
    },
    getFileIcon(ex) {
      return getFileIcon(ex);
    },
    showDetail(t) {
      if (this.$route.params.bot == 6 || this.$route.params.bot == 286) {
        this.$emit("on-detail", t);
      } else {
        this.$router.push({
          name: "lmsLessonView",
          params: {
            id: this.$route.params.id,
            cid: this.$route.params.cid,
            bid: this.box.id,
            iid: t.id,
            bot: this.box.ot
          }
        });
      }
    }
  }
};
</script>

<style></style>
